import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div
      style={{
        position: "absolute",
        bottom: "0",
        left: "0",
        right: "0",
        padding: "20px 0",
        textAlign: "center",
        borderTop: "1px solid #8D8E9C",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "40px",
      }}
    >
      <p>© {new Date().getFullYear()}. All rights reserved.</p>
      <Link to="/privacy" style={{ color: "#181C23", textDecoration: "underline" }}>
        Privacy Policy
      </Link>
      <Link to="/terms" style={{ color: "#181C23", textDecoration: "underline" }}>
        Terms of Service
      </Link>
    </div>
  );
};

export default Footer;